import cookpadFull from 'marketing-website/components/icons/cookpadFull';
import statsImage from 'marketing-website/media/images/pages/case-studies/cookpad/stats@2x.jpg';
import image01a from 'marketing-website/media/images/pages/case-studies/cookpad/image-01-a@2x.jpg';
import image01b from 'marketing-website/media/images/pages/case-studies/cookpad/image-01-b@2x.jpg';
import image02a from 'marketing-website/media/images/pages/case-studies/cookpad/image-02-a@2x.jpg';
import image02b from 'marketing-website/media/images/pages/case-studies/cookpad/image-02-b@2x.jpg';
import image03a from 'marketing-website/media/images/pages/case-studies/cookpad/image-03-a@2x.jpg';
import image03b from 'marketing-website/media/images/pages/case-studies/cookpad/image-03-b@2x.png';
import image04a from 'marketing-website/media/images/pages/case-studies/cookpad/image-04-a@2x.jpg';
import image04b from 'marketing-website/media/images/pages/case-studies/cookpad/image-04-b-alternative@2x.jpg';
import imageQuote from 'marketing-website/media/images/pages/case-studies/cookpad/quote@2x.jpg';

const cookPadAssets = {
  heroLogo: cookpadFull,
  statsImage: {
    alt: 'Marvel Prototyping used by CookPad',
    maxWidth: 1290,
    src: statsImage,
  },
  stats: [
    {
      id: 0,
      stat: '100',
      title: 'validation tests',
      copy:
        'Cookpad run tests with Marvel for Product Discovery across 5 squads each week',
    },
    {
      id: 1,
      stat: '35',
      title: 'countries globally',
      copy:
        'Their design teams test with their international audiences around the world using Marvel prototypes',
    },
    {
      id: 2,
      stat: '100',
      title: 'million users',
      copy: `Every month Cookpad has over 100 million users visit their platform`,
    },
  ],
  doubleImages: {
    first: [
      {
        src: image01a,
        maxWidth: 536,
        alt: 'collaboration',
      },
      {
        src: image01b,
        maxWidth: 551,
        alt: 'team meetings',
      },
    ],
    second: [
      {
        src: image02a,
        maxWidth: 550,
        alt: 'iOS prototyping',
      },
      {
        src: image02b,
        maxWidth: 550,
        alt: 'cooking',
      },
    ],
    third: [
      {
        src: image03a,
        maxWidth: 556,
        alt: 'Cookpad and Marvel',
      },
      {
        src: image03b,
        maxWidth: 556,
        alt: 'Marvel and Cookpad',
      },
    ],
    fourth: [
      {
        src: image04a,
        maxWidth: 556,
        alt: 'Cookpad and Marvel',
      },
      {
        src: image04b,
        maxWidth: 550,
        alt: 'iOS and desktop prototyping',
      },
    ],
    fifth: [
      {
        src: imageQuote,
        maxWidth: 556,
        alt: 'mobile prototyping',
      },
      {
        maxWidth: 440,
        copy:
          '“We use the Sketch integration primarily, which syncs with Marvel and instantly updates as we need to. It takes no time at all.”',
      },
    ],
  },
};

export default cookPadAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/cookpad.js